import { MutableRefObject, useEffect } from 'react';

const useOutsideClick = (
  ref: MutableRefObject<HTMLElement | null>,
  callback: () => void,
  disabled?: boolean,
  parentRootId?: string,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (disabled) return;
      // Only bail out for modal-root clicks when the ref itself is outside the
      // modal — prevents dropdowns mounted in the page from closing when the
      // user interacts with a modal, but still allows components inside the
      // modal to respond to clicks elsewhere within it.
      if (!parentRootId) {
        const modalRoot = document.getElementById('modal-root');
        const refIsInsideModal = modalRoot?.contains(ref.current) ?? false;
        if (
          !refIsInsideModal &&
          modalRoot &&
          modalRoot.contains(event.target as Node)
        )
          return;
      }
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    const listenerTarget = parentRootId
      ? (document.getElementById(parentRootId) ?? document)
      : document;

    listenerTarget.addEventListener(
      'mousedown',
      handleClickOutside as EventListener,
    );
    return () => {
      listenerTarget.removeEventListener(
        'mousedown',
        handleClickOutside as EventListener,
      );
    };
  }, [ref, callback, disabled, parentRootId]);
};

export default useOutsideClick;
